/** Client diagnostics — never log raw token, response body, or internal IDs. */

export function logPromptLoaded(): void {
  console.info("STORYBOOK WEB PROMPT LOADED");
}

export function logSubmitStart(): void {
  console.info("STORYBOOK WEB SUBMIT START");
}

export function logSubmitSuccess(): void {
  console.info("STORYBOOK WEB SUBMIT SUCCESS");
}

export function logSubmitFailure(reason: string): void {
  const safe = reason.replace(/[\r\n]/g, " ").slice(0, 120);
  console.info(`STORYBOOK WEB SUBMIT FAILURE reason=${safe}`);
}
